/* ═══════════════════════════════════════════════════════════
   Lukujen esitys — yksi määritelmä, ei viittä.

   Sama luku näkyi eri näkymissä eri tavalla: `luku()` oli kopioituna
   viiteen tiedostoon muodossa `toFixed(1).replace(".", ",")`, ja
   muualla käytettiin `toLocaleString`ia. Desimaalierotin oli molemmissa
   pilkku, mutta tuhaterotin vain jälkimmäisessä — joten sama määrä
   näkyi toisaalla "1234,5" ja toisaalla "1 234,5".

   Se ei ole virhe vaan epäjohdonmukaisuus, ja juuri sen lajin jonka
   messuosastolla huomaa sekunnissa.

   Kokonaisluku näytetään ilman desimaaleja: "40 tuntia", ei "40,0".
   ═══════════════════════════════════════════════════════════ */

import { lokaali } from "./kieli";

// T439 (7.10.2026): lokaali käyttäjän kielen mukaan (fi-FI / en-GB), luetaan joka kutsulla.

/** Yleisluku: kokonaisluku ilman desimaaleja, muuten yksi desimaali. */
export const luku = (n: number): string =>
  (n ?? 0).toLocaleString(lokaali(), { maximumFractionDigits: 1 });

/** Luku kiinteällä tarkkuudella — esim. rahasummat ja dia-inch. */
export const luvut = (n: number, desimaaleja = 1): string =>
  (n ?? 0).toLocaleString(lokaali(), {
    minimumFractionDigits: desimaaleja,
    maximumFractionDigits: desimaaleja,
  });

/** Osuus prosentteina. Nolla-nimittäjä on viiva, ei "NaN %" eikä "0 %". */
export const prosentti = (osa: number, kokonaisuus: number, desimaaleja = 1): string =>
  kokonaisuus > 0 ? `${luvut((100 * osa) / kokonaisuus, desimaaleja)} %` : "—";
